/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import {
  propTypesAltLanguage,
  propTypesFAQContent,
  propTypesIllustration,
  propTypesLink,
  propTypesTextHtml,
} from '../../shared/constants/Proptypes';

export const propTypesPricing = {
  last_publication_date: PropTypes.string,
  first_publication_date: PropTypes.string,
  lang: PropTypes.string,
  url: PropTypes.string,
  type: PropTypes.string,
  uid: PropTypes.string,
  prismicId: PropTypes.string,
  alternate_languages: PropTypes.arrayOf(PropTypes.shape(propTypesAltLanguage)),
  data: PropTypes.shape({
    breadcrumb: PropTypes.shape({
      parent_document: PropTypes.shape({
        lang: PropTypes.string,
        type: PropTypes.string,
        uid: PropTypes.string,
        url: PropTypes.string,
      }),
      parent_name: PropTypes.string,
    }),
    breadcrumb_title: PropTypes.string,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        cta_datatrack_attribute: PropTypes.string,
        cta_label: PropTypes.string,
        cta_link: PropTypes.shape(propTypesLink),
        cta_type: PropTypes.string,
        frequency_tooltip: PropTypes.string,
        team_badge: PropTypes.string,
        offer_badge: PropTypes.string,
        offer_description: PropTypes.shape(propTypesTextHtml),
        offer_name: PropTypes.string,
        offer_price: PropTypes.string,
        offer_price_usd: PropTypes.string,
        offer_price_cad: PropTypes.string,
        offer_price_gbp: PropTypes.string,
        offer_price_frequency: PropTypes.string,
        plan_name: PropTypes.string,
        price_tooltip: PropTypes.string,
      })
    ),
    faq_content: PropTypes.arrayOf(PropTypes.shape(propTypesFAQContent)),
    faq_description: PropTypes.string,
    faq_title: PropTypes.string,
    features: PropTypes.arrayOf(
      PropTypes.shape({
        column_four_has_feature: PropTypes.string,
        column_four_text: PropTypes.string,
        column_one_has_feature: PropTypes.string,
        column_one_text: PropTypes.string,
        column_three_has_feature: PropTypes.string,
        column_three_text: PropTypes.string,
        column_two_has_feature: PropTypes.string,
        column_two_text: PropTypes.string,
        feature_badge: PropTypes.string,
        feature_description: PropTypes.string,
        feature_name: PropTypes.string,
      })
    ),
    features_plan_four: PropTypes.arrayOf(
      PropTypes.shape({
        feature_name_plan_four: PropTypes.string,
      })
    ),
    features_plan_one: PropTypes.arrayOf(
      PropTypes.shape({
        feature_name_plan_one: PropTypes.string,
      })
    ),
    features_plan_three: PropTypes.arrayOf(
      PropTypes.shape({
        feature_name_plan_three: PropTypes.string,
      })
    ),
    features_plan_two: PropTypes.arrayOf(
      PropTypes.shape({
        feature_name_plan_two: PropTypes.string,
      })
    ),
    illustration: PropTypes.shape(propTypesIllustration),
    main_title: PropTypes.shape(propTypesTextHtml),
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
    og_description: PropTypes.string,
    pricing_details_description: PropTypes.string,
    pricing_details_title: PropTypes.string,
    pricing_segments: PropTypes.arrayOf(
      PropTypes.shape({
        is_segment_selected: PropTypes.bool,
        segment_name: PropTypes.string,
        segment_url: PropTypes.shape(propTypesLink),
      })
    ),
    questions: PropTypes.arrayOf(
      PropTypes.shape({
        answer_part: PropTypes.shape(propTypesTextHtml),
        question_part: PropTypes.string,
      })
    ),
    summary_plan_four: PropTypes.string,
    summary_plan_one: PropTypes.string,
    summary_plan_three: PropTypes.string,
    summary_plan_two: PropTypes.string,
  }),
};
